export const apiConfig = JSON.parse(process.env.VUE_APP_API_CONFIG);